import React, {useState, useEffect} from 'react'
import Arrow from '../icons/arrow'

const Accordion = (props) => {
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    if (typeof props.open === 'boolean' && props.open !== expanded) {
      setExpanded(props.open)
    }
  }, [props.open])

  return (
    <div className='w-full text-sm overflow-hidden'>
      <label
        onClick={() => {
          setExpanded(!expanded)
        }}
        className='block p-2 border border-gray-200 cursor-pointer'>
        {!props.hideArrow &&
          (expanded ? (
            <Arrow direction='down' size={props.arrow_size || 6} />
          ) : (
            <Arrow direction='right' size={props.arrow_size || 6} />
          ))}
        {props.header}
      </label>

      {expanded ? (
        <div className='border-b border-r border-gray-200'>
          <div className='overflow-hidden border-l-2 border-primary'>
            <div className='p-2'>{props.children}</div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

export default Accordion
